<template>
  <section class="extra-scroll-block content">
      <div class="row-4-desk-gradual ">
       <div class="extra-scroll-block__wrap">
        <slot />
        

          
     </div>
   </div>
    </section>
</template>

<script>
export default {
  name: 'PagesCommonHero',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  routeLink: Object,
  title: 'String'
  
})

const router = useRouter()
const localePath = useLocalePath()

let extraScroll = 0; // Contatore per lo scroll extra
const SCROLL_THRESHOLD = 500; // Soglia di 300 px virtuali
const isTransitioning = ref(false)
const extraScrollPercentage = ref(0)
let touchStartY = 0


/*onMounted(() => {
window.addEventListener('wheel', handleScroll);
window.addEventListener('touchmove', handleScroll, { passive: false }); // Per dispositivi mobili
 window.addEventListener('touchstart', (event) => {
    touchStartY = event.touches[0].clientY;
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('wheel', handleScroll);
  window.removeEventListener('touchmove', handleScroll);
  window.removeEventListener('touchstart', () => {})
})

const handleScroll = (event) => {
  const baretta = document.querySelector('.progress-bar-violet')
  console.log('dentro handleSCroll')
  const scrollPosition = window.innerHeight + window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;

  console.log(scrollPosition, documentHeight)


  if (scrollPosition >= documentHeight - 5 && !isTransitioning.value) {
    // L'utente è al fondo: registra il movimento di scroll extra
   let scrollDelta = 0;

    // Determina il delta per il movimento del mouse (wheel) o touch (touchmove)
    if (event.type === 'wheel') {
      scrollDelta = event.deltaY; // movimento della rotella del mouse
    } else if (event.type === 'touchmove') {
      const touch = event.touches[0];
    scrollDelta = touchStartY - touch.clientY;
    touchStartY = touch.clientY // movimento del tocco su dispositivi mobili
    }

    // Accumula lo scroll extra
    extraScroll += scrollDelta;
    console.log(extraScroll, extraScrollPercentage.value)
    extraScrollPercentage.value = Math.min(100, (extraScroll / SCROLL_THRESHOLD) * 100)

      // Riempi la progress bar in base allo scroll extra
      gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })

    if (extraScroll >= SCROLL_THRESHOLD - 5) {
      console.log('dentro if extra scroll')
      // Cambia pagina e resetta il contatore
      
       if (extraScrollPercentage.value >= 99) {
        isTransitioning.value = true;
        setTimeout(() => {
        router.push(localePath(props.routeLink.value));
      }, 500) // Sostituisci '/next-page' con il percorso desiderato
      }
       // Ritardo per l'animazione (0.5s corrisponde a .page-fade)
    }
  } else {
    isTransitioning.value = false;
    // Resetta il contatore se l'utente scrolla verso l'alto o non è al fondo
    extraScroll = 0;
    extraScrollPercentage.value = 0
    gsap.to(baretta, {
        width: `${extraScrollPercentage.value}%`,
        duration: 0.1,
      })
  }
}*/

</script>

<style lang="scss">
@import './style.scss';
</style>
